export default class Progressive {
    id = 0;
    boosts = true;
    name = null;
    mastodon = null;
    mastodonUrl = null;
    title = null;
    publication = null;
    twitter = null;
    focus = null;
    include = false;
    knownPublications = [];

    constructor(id) {
        this.id = id;
    }
}
